import { EmptyCell, type IColumn } from 'shared/ui'
import { type RowNumber } from 'entities/Phone/model/Table/RowNumber'
import { InboxCell } from 'entities/Inbox/ui/InboxCell/InboxCell'

export const inboxCell: IColumn<RowNumber> = {
  field: 'inboxName',
  name: 'Inbox',
  isDisabledChangeVisible: true,
  isSortable: true,
  sortKey: 'inbox',
  renderRowCell: (row) => {
    const { disabled } = row
    const { itemInbox } = row.origin

    return itemInbox ? (
      <InboxCell name={itemInbox?.name} id={itemInbox?.id} disabled={disabled} />
    ) : (
      <EmptyCell />
    )
  },
}
